import { useEffect } from "react";
import { SITE_URL, SITE_NAME } from "../data/seoConfig";

const setMetaTag = (attribute, key, content) => {
  if (!content) return;

  const selector =
    attribute === "name"
      ? `meta[name="${key}"]`
      : `meta[property="${key}"]`;

  let element = document.querySelector(selector);

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
};

const setCanonicalLink = (url) => {
  let element = document.querySelector('link[rel="canonical"]');

  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", "canonical");
    document.head.appendChild(element);
  }

  element.setAttribute("href", url);
};

const SEO = ({ title, description, keywords, path = "/", image }) => {
  const canonicalUrl = `${SITE_URL}${path}`;
  const pageTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;

  useEffect(() => {
    document.title = pageTitle;

    setMetaTag("name", "description", description);
    setMetaTag("name", "keywords", keywords);

    setMetaTag("property", "og:title", pageTitle);
    setMetaTag("property", "og:description", description);
    setMetaTag("property", "og:type", "website");
    setMetaTag("property", "og:url", canonicalUrl);
    setMetaTag("property", "og:image", image);
    setMetaTag("property", "og:site_name", SITE_NAME);

    setMetaTag("name", "twitter:card", "summary_large_image");
    setMetaTag("name", "twitter:title", pageTitle);
    setMetaTag("name", "twitter:description", description);
    setMetaTag("name", "twitter:image", image);

    setCanonicalLink(canonicalUrl);
  }, [pageTitle, description, keywords, canonicalUrl, image]);

  return null;
};

export default SEO;
